// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_jSGyT {
  z-index: 999;
  position: absolute;
}
.bg_X3qu2 {
  position: fixed;
  height: 100vh;
  width: 100vw;
  background-color: var(--_00000020-background);
  top: 0;
  left: 0;
}
.variableModal_QRXpP {
  position: fixed;
  background-color: var(--f5-background);
  z-index: 4;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;
  overflow: hidden;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
}

.contentVariableModal__N6jd {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: var(--f5-background);
  padding: 0px 8px 8px;
  .content_HNWtU {
    margin: 0 auto;
    width: 90%;
    background-color: var(--white-color);
    padding: 12px;
    gap: 20px;
    display: flex;
    flex-direction: column;
    border-radius: 14px;
    -webkit-border-radius: 14px;
    .multiConcept_HEvHC {
      color: #666666;
      font-size: 13px;
    }
    p {
      color: #000000;
      font-weight: 500;
      margin: 0;
    }
    input,textarea {
      font-size: 18px;
      font-weight: 500;
      margin: 0;
      width: 100%;
      border-radius: 8px;
      padding: 6px;
      border: none;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      -ms-border-radius: 8px;
      -o-border-radius: 8px;
      background-color: var(--f4-background);
      outline: none;
      font-size: 13px;
      resize: none;
      field-sizing: content;
    }
    textarea{
      min-height: 50px;
      max-height: 150px;
    }
  }
.variablesList_TuBXG{
  border-top: 1px solid var(--_e6-color);
  border-bottom: 1px solid var(--_e6-color);
  padding: 20px 0;
  max-height: 100px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  scrollbar-width: none; 
}

.variablesList_TuBXG::-webkit-scrollbar {
  display: none; 
}
  .variableItem_gwYtg {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    justify-content: space-between;
    margin: 0;
    .leftSideVariableItem_Bockk{
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .infoVariable_aM2Wm {
      display: flex;
      flex-direction: column;
      p {
        color: #09090b;
      }

      span {
        font-size: 13px;
        color: #b6b6b6;
      }
    }
    input {
      width: fit-content;
    }
  }
}


.requiredContainer_ARgnS{
  display: flex;
  align-items: center;
  gap: 10px;
  input{
    width: fit-content !important;
  }
}

.titleTypeContainer_JzGRa{
  display: flex;
  align-items: center;
  gap: 10px;
  input{
    flex: 1 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/VariableModal/VariableModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,6CAA6C;EAC7C,MAAM;EACN,OAAO;AACT;AACA;EACE,eAAe;EACf,sCAAsC;EACtC,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sCAAsC;EACtC,oBAAoB;EACpB;IACE,cAAc;IACd,UAAU;IACV,oCAAoC;IACpC,aAAa;IACb,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B;MACE,cAAc;MACd,eAAe;IACjB;IACA;MACE,cAAc;MACd,gBAAgB;MAChB,SAAS;IACX;IACA;MACE,eAAe;MACf,gBAAgB;MAChB,SAAS;MACT,WAAW;MACX,kBAAkB;MAClB,YAAY;MACZ,YAAY;MACZ,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;MACrB,sCAAsC;MACtC,aAAa;MACb,eAAe;MACf,YAAY;MACZ,qBAAqB;IACvB;IACA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF;EACE,sCAAsC;EACtC,yCAAyC;EACzC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,8BAA8B;IAC9B,SAAS;IACT;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;IACA;MACE,aAAa;MACb,sBAAsB;MACtB;QACE,cAAc;MAChB;;MAEA;QACE,eAAe;QACf,cAAc;MAChB;IACF;IACA;MACE,kBAAkB;IACpB;EACF;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,SAAO;EACT;AACF","sourcesContent":[".overlay {\n  z-index: 999;\n  position: absolute;\n}\n.bg {\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n  background-color: var(--_00000020-background);\n  top: 0;\n  left: 0;\n}\n.variableModal {\n  position: fixed;\n  background-color: var(--f5-background);\n  z-index: 4;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 8px;\n  overflow: hidden;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n}\n\n.contentVariableModal {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  background-color: var(--f5-background);\n  padding: 0px 8px 8px;\n  .content {\n    margin: 0 auto;\n    width: 90%;\n    background-color: var(--white-color);\n    padding: 12px;\n    gap: 20px;\n    display: flex;\n    flex-direction: column;\n    border-radius: 14px;\n    -webkit-border-radius: 14px;\n    .multiConcept {\n      color: #666666;\n      font-size: 13px;\n    }\n    p {\n      color: #000000;\n      font-weight: 500;\n      margin: 0;\n    }\n    input,textarea {\n      font-size: 18px;\n      font-weight: 500;\n      margin: 0;\n      width: 100%;\n      border-radius: 8px;\n      padding: 6px;\n      border: none;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n      background-color: var(--f4-background);\n      outline: none;\n      font-size: 13px;\n      resize: none;\n      field-sizing: content;\n    }\n    textarea{\n      min-height: 50px;\n      max-height: 150px;\n    }\n  }\n.variablesList{\n  border-top: 1px solid var(--_e6-color);\n  border-bottom: 1px solid var(--_e6-color);\n  padding: 20px 0;\n  max-height: 100px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  scrollbar-width: none; \n}\n\n.variablesList::-webkit-scrollbar {\n  display: none; \n}\n  .variableItem {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    gap: 10px;\n    justify-content: space-between;\n    margin: 0;\n    .leftSideVariableItem{\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n    .infoVariable {\n      display: flex;\n      flex-direction: column;\n      p {\n        color: #09090b;\n      }\n\n      span {\n        font-size: 13px;\n        color: #b6b6b6;\n      }\n    }\n    input {\n      width: fit-content;\n    }\n  }\n}\n\n\n.requiredContainer{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  input{\n    width: fit-content !important;\n  }\n}\n\n.titleTypeContainer{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  input{\n    flex: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_jSGyT`,
	"bg": `bg_X3qu2`,
	"variableModal": `variableModal_QRXpP`,
	"contentVariableModal": `contentVariableModal__N6jd`,
	"content": `content_HNWtU`,
	"multiConcept": `multiConcept_HEvHC`,
	"variablesList": `variablesList_TuBXG`,
	"variableItem": `variableItem_gwYtg`,
	"leftSideVariableItem": `leftSideVariableItem_Bockk`,
	"infoVariable": `infoVariable_aM2Wm`,
	"requiredContainer": `requiredContainer_ARgnS`,
	"titleTypeContainer": `titleTypeContainer_JzGRa`
};
export default ___CSS_LOADER_EXPORT___;
